import React from 'react';

const NoAccessComponent = () => {
  return <div>No tienes acceso a esta sección, comunicate con tu administrador de sistema.</div>
};

export default NoAccessComponent;